import { cloneDeep } from 'lodash';
import React, { Component } from 'react';

import { Loader, NoResult } from '../../misc/loader-utils';
import dashboardService from '../../publisher/dashboard/dashboard-service';
import { dateService } from '../../../services/date';
import { formatValue } from '../../base/common/utils';

import '../../publisher/dashboard/change-icons.scss';
import '../../publisher/dashboard/totals-hero.scss';

class TotalsHero extends Component {
  constructor(props) {
    super(props);

    this.service = dashboardService;

    this.state = {
      loading: true,
      showNoResult: false,
      stats: [
        {
          name: 'spend',
          label: 'Spend',
          value: 0,
        },
        {
          name: 'revenue',
          label: 'Revenue',
          value: 0,
        },
        {
          name: 'roa',
          label: 'ROAS',
          value: 0,
        },
      ],
    };
  }

  componentDidMount() {
    this.queryEarningsStats();
  }

  queryEarningsStats() {
    const dateRange = dateService.getPresetDateRanges().thisMonth;
    const params = {
      date_from: dateService.formatDate(dateRange.startDate),
      date_to: dateService.formatDate(dateRange.endDate),
    };

    this.service
      .getMerchantStatsByMonth(this.props.merchId, params)
      .then(resp => {
        const monthlyStats = resp[resp.length - 1];
        const stats = cloneDeep(this.state.stats);
        stats[0].value = this.formatValue(monthlyStats.spend);
        stats[1].value = this.formatValue(monthlyStats.revenue);
        stats[2].value = this.formatValue(monthlyStats.roa, 'roa');

        this.setState({
          loading: false,
          showNoResult: false,
          stats,
        });
      })
      .catch(() => {
        this.showNoResult();
      });
  }

  /* Helper functions */
  formatValue(val, type) {
    if (type === 'roa') {
      return parseFloat(val).toFixed(1);
    }
    return formatValue(val, 'currency', 'spend');
  }

  showNoResult() {
    this.setState({
      showNoResult: true,
      loading: false,
    });
  }

  render() {
    const fieldInfo =
      !this.state.loading && !this.state.showNoResult
        ? this.state.stats.map(stat => {
            return (
              <div className="totals-hero" key={stat.name}>
                <div className={`field-info ${stat.name}`}>
                  <div className={`date-label ${stat.name}`}>{stat.label}</div>
                  <div className={`value ${stat.name}`}>{stat.value}</div>
                  <div className="comparison">This Month</div>
                </div>
              </div>
            );
          })
        : null;

    return (
      <div className="totals-hero-container merchant">
        <Loader loading={this.state.loading} />
        <NoResult type="total-earnings" noResult={!this.state.loading && this.state.showNoResult} />
        {fieldInfo}
      </div>
    );
  }
}

export default TotalsHero;
